export default {
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        finishLoading(silently) {
            if (!silently) {
                this.loading = true
            }
            return () => (this.loading = false)
        },

        loadingUntil(working) {
            this.loading = true

            working(() => {
                this.loading = false
            })
        },
    },
}
